import { Task, TaskCheckOptions, Timestamp, WeekDays } from '@griply/types';
import { isAfter, isSameDay } from 'date-fns';

import { getTaskCheckOption } from './get-task-check-option';
import { isTimeslotAction } from './is-timeslot-action';

export type GetCalendarOccurrenceCheckStateOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export type CalendarOccurrenceCheckState = {
  checkOption: TaskCheckOptions;
  isFutureRepeating: boolean;
  completed: boolean;
};

// Single source of the calendar card check-state rule — the comparator's `completed` and both apps' cards must agree.
export const getCalendarOccurrenceCheckState = (
  task: Task,
  referenceDate: Timestamp,
  { today, weekStartsOn }: GetCalendarOccurrenceCheckStateOptions,
): CalendarOccurrenceCheckState => {
  const checkOption = getTaskCheckOption(task, {
    day: referenceDate,
    today,
    weekStartsOn,
    showRepeatingAsTodo: true,
  });
  const isFutureRepeating =
    !!task.schedules?.length &&
    !isSameDay(referenceDate, today) &&
    isAfter(referenceDate, today);
  const completed = isTimeslotAction(task.action?.type)
    ? !!task.completedAt
    : checkOption !== TaskCheckOptions.Unchecked && !isFutureRepeating;

  return { checkOption, isFutureRepeating, completed };
};
